import React from 'react'
import LoginForm from 'components/Auth/Signin'
import AuthLeftSide from 'components/Auth/InfoAuthLeftSide'
import { Row, Col } from 'antd'
const Login = () => {
    return (
        <div className="gx-authBackGround">
            <Row>
                <Col xl={12} lg={12} md={12} sm={24} xs={0}>
                    <AuthLeftSide />
                </Col>
                <Col xl={12} lg={12} md={12} sm={24} xs={24}>
                    <LoginForm />
                </Col>
            </Row>
        </div>
    )
}

export default Login
